import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Shared";
import { LINKS } from "@/lib/site";

export default function Founder() {
  return (
    <section id="about" className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Founder's Corner</Eyebrow>
        </Reveal>

        <div className="mt-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <Reveal className="lg:col-span-5" delay={0.05}>
            <div className="relative">
              <div className="overflow-hidden rounded-2xl border border-[#0B1F3A]/8 shadow-[0_20px_50px_rgba(11,31,58,0.10)]">
                <img
                  src="/assets/founder.png"
                  alt="Arvind Sura, Founder of Nexfold Consults"
                  data-testid="founder-portrait"
                  className="w-full object-cover grayscale"
                />
              </div>
              <div className="absolute -bottom-5 left-6 rounded-xl bg-[#0B1F3A] px-6 py-4 shadow-lg">
                <p className="font-display text-lg font-bold text-white">Arvind Sura</p>
                <p className="text-xs uppercase tracking-[0.18em] text-[#C8A75D]">
                  Founder and Director
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-7" delay={0.12}>
            <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight leading-[1.1] text-[#0B1F3A]">
              The Story Behind Nexfold
            </h2>
            <div className="mt-8 space-y-5 text-base md:text-lg leading-relaxed text-[#4B5563]">
              <p>
                Behind every ambition is a journey. Behind every journey is the need for
                the right guidance.
              </p>
              <p>
                Hi, I'm Arvind Sura, Founder of Nexfold Consults Limited.
              </p>
              <p>
                Nexfold is created from a simple observation — many talented individuals
                have the ambition to achieve more, but often lack the right direction,
                support, and clarity to turn their goals into reality.
              </p>
              <p>
                During my own journey as an international student in the UK, I experienced
                the challenges of adapting to a new environment, understanding new
                opportunities, and making important decisions about the future. I realised
                that having access to practical guidance and the right support at the right
                time can make a significant difference.
              </p>
              <p>
                That realisation became the foundation of Nexfold.
              </p>
              <p>
                Our mission is to help students, professionals, entrepreneurs, and business
                owners navigate their next steps with confidence. Whether it is building a
                career, launching a business, or creating opportunities for growth, we focus
                on providing honest guidance, practical solutions, and personalised support.
              </p>
              <p>
                Every individual and every business has a unique journey. Our role isn't
                simply to provide advice — it's to understand your vision, recognise your
                challenges, and work alongside you with tailored guidance that creates
                lasting value, meaningful progress, and the confidence to take your next
                step.
              </p>
              <p className="text-[#1F2937] font-medium">
                Thank you for trusting Nexfold to be part of your journey.
              </p>
            </div>
            <div className="mt-10">
              <a
                href={LINKS.instagramDM}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cta-book-consultation-founder"
                className="group inline-flex items-center gap-2 rounded-full bg-[#0B1F3A] px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-[#C8A75D] hover:text-[#0B1F3A]"
              >
                Book a Consultation
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
